if (!customElements.get("cart-action-popup")) {
  customElements.define(
    "cart-action-popup",
    class CartActionPopup extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(".cart_notification_action_button");
        this.CancelButtons = this.querySelectorAll(".button__cancel");
        this.SaveButtons = this.querySelectorAll(".button__save");
        this.actionOverlay = this.closest("cart-notification")?.querySelector(
          ".cart_action_drawer_overlay"
        );
        this.cartNote = this.querySelector("#cart_note_drawer");
        this.cartNoteValue = this.querySelector("#cartNote");
        this.shippingDrawer = this.querySelector("#shipping_drawer");

        this.shippingCountry = this.querySelector("#AddressCountry_Shipping");
        this.countryState = this.querySelector("#AddressProvince_shipping");
        this.shippingCountryZip = this.querySelector("#ShippingAddressZip");

        this.actions = {
          note: "note",
          shipping: "shipping",
        };

        this.button?.addEventListener("click", (event) => {
          event.preventDefault();
          if (this.button.dataset.action === this.actions.note) {
            this.open();
            this.cartNote.classList.add("active");
          } else if (this.button.dataset.action === this.actions.shipping) {
            this.open();
            this.shippingDrawer.classList.add("active");
          }

          if (this.cartNoteValue) {
            fetch("/cart.js")
              .then((res) => res.json())
              .then((json) => {
                this.cartNoteValue.value = json.note;
              });
          }

          if (this.shippingCountry && this.countryState && Shopify?.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector(
              "AddressCountry_Shipping",
              "AddressProvince_shipping",
              { hideElement: "AddressProvinceContainerNewShiping" }
            );
          }
        });

        this.CancelButtons.forEach((btn) => btn?.addEventListener("click", this.close.bind(this)));

        this.SaveButtons.forEach((btn) => {
          if (btn.dataset.action === "note") {
            btn.addEventListener("click", this.saveCartNote.bind(this, btn));
          } else if (btn.dataset.action === "shipping") {
            btn.addEventListener("click", this.shippingCalc.bind(this, btn));
          }
        });
      }

      open() {
        this.actionOverlay?.classList.add("active");
      }

      close() {
        this.actionOverlay?.classList.remove("active");
        this.cartNote?.classList.remove("active");
        this.shippingDrawer?.classList.remove("active");
      }

      saveCartNote(button) {
        button.classList.add("loading");
        const body = JSON.stringify({ note: this.cartNoteValue.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((res) => res.json())
          .then(() => {
            this.cartNote.classList.remove("active");
            this.actionOverlay.classList.remove("active");
            button.classList.remove("loading");
          });
      }

      shippingCalc(button) {
        const ratePackage = this.querySelector(".shipping_rate_package");
        const addressWrapper = this.querySelector(".shipping_rate_message");
        const addressCount = this.querySelector(".shipping_address_count");

        ratePackage.innerHTML = "";

        if (this.shippingCountry.value !== "---") {
          button.classList.add("loading");
          fetch(
            `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${this.shippingCountryZip.value}&shipping_address%5Bcountry%5D=${this.shippingCountry.value}&shipping_address%5Bprovince%5D=${this.countryState.value}`
          )
            .then((res) => {
              if (!res.ok) throw `${window.shipping.wrong_message}`;
              return res.json();
            })
            .then((data) => {
              button.classList.remove("loading");
              addressWrapper.classList.remove("no-js-inline");
              addressCount.innerText = `${data.shipping_rates.length}`;
              data.shipping_rates.forEach((rate) => {
                const p = document.createElement("p");
                p.className = "mb-0";
                p.innerText = `${rate.name}: ${shopCurrencySymbol}${rate.price}`;
                ratePackage.appendChild(p);
              });
            })
            .catch((err) => {
              button.classList.remove("loading");
              addressWrapper.classList.add("no-js-inline");
              ratePackage.innerHTML = `<p class="error mt-15">${err}</p>`;
            });
        } else {
          addressWrapper.classList.add("no-js-inline");
          ratePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
        }
      }
    }
  );
}

/* -------------------------
   CART DRAWER CONTROLS
------------------------- */
(function () {
  const DRAWER_SELECTOR = "#offcanvas__mini_cart";

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add("open", "active", "show");
    document.body.classList.add("overflow-hidden");
    document.querySelectorAll(".cart-overlay, .drawer-overlay, #offcanvas-backdrop").forEach((el) =>
      el.classList.add("active", "show")
    );
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove("open", "active", "show");
    document.body.classList.remove("overflow-hidden");
    document.querySelectorAll(".cart-overlay, .drawer-overlay, #offcanvas-backdrop").forEach((el) =>
      el.classList.remove("active", "show")
    );
  }

  function renderDrawer(html) {
    const drawer = getDrawer();
    if (!drawer) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const freshDrawer = doc.querySelector(DRAWER_SELECTOR);
    if (!freshDrawer) return;
    drawer.innerHTML = freshDrawer.innerHTML;
  }

  function refreshDrawer(open = false) {
    const drawer = getDrawer();
    if (!drawer) return;
    const sectionWrapper = drawer.closest(".shopify-section");
    if (!sectionWrapper) return;
    const SECTION_ID = sectionWrapper.id.replace("shopify-section-", "");

    fetch(`/?sections=${SECTION_ID}`)
      .then((res) => res.json())
      .then((sections) => {
        renderDrawer(sections[SECTION_ID]);
        if (open) openDrawer();
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    refreshDrawer(false); // just load the drawer, do NOT open
  });

  /* -------------------------
     ADD TO CART
  ------------------------- */
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target.closest('form[action^="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { "X-Requested-With": "XMLHttpRequest" },
      }).then(() => setTimeout(() => refreshDrawer(true), 150)); // open drawer after add
    },
    true
  );

  /* -------------------------
     CLICK DELEGATION FOR DRAWER CLOSE
  ------------------------- */
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.cart-notification__close');
    const overlayClick = e.target.classList.contains('cart_action_drawer_overlay');

    if (!closeBtn && !overlayClick) return;

    const drawer = e.target.closest('cart-notification');
    if (!drawer) return;

    drawer.classList.remove('open', 'active', 'show');
    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('added__overlay'); // 🔥 THIS fixes :before
  });

  /* ===============================
   CART DRAWER QUANTITY — FINAL FIX
   =============================== */

document.addEventListener(
  "pointerdown",
  function (e) {
    const btn = e.target.closest(".quantity__button");
    if (!btn) return;

    // 🔥 Kill Shopify's handler before it runs
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const wrapper = btn.closest(".cart-notification__quantity-wrapper");
    if (!wrapper) return;

    const input = wrapper.querySelector(".quantity__input");
    if (!input) return;

    const line = parseInt(input.dataset.line, 10);
    if (!line) return;

    let quantity = parseInt(input.value, 10) || 1;

    if (btn.name === "plus") quantity += 1;
    if (btn.name === "minus") quantity -= 1;

    quantity = Math.max(1, quantity);

    updateCartLine(line, quantity, input);
  },
  true // 🔥 capture phase
);

/* ===============================
   MANUAL INPUT
   =============================== */
document.addEventListener(
  "change",
  function (e) {
    const input = e.target.closest(".quantity__input");
    if (!input) return;

    const line = parseInt(input.dataset.line, 10);
    if (!line) return;

    let quantity = parseInt(input.value, 10) || 1;
    quantity = Math.max(1, quantity);

    updateCartLine(line, quantity, input);
  },
  true
);

/* ===============================
   SINGLE SOURCE OF TRUTH
   =============================== */
function updateCartLine(line, quantity, input) {
  input.disabled = true;

  // Request the specific sections to re-render
  const body = JSON.stringify({
    line,
    quantity,
    sections: ["cart-notification", "cart-notification-count"],
    sections_url: window.location.pathname,
  });

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  })
    .then((res) => res.json())
    .then((parsedState) => {
      if (parsedState.errors) {
        console.error("Cart update errors:", parsedState.errors);
        input.disabled = false;
        return;
      }

      // Helper to extract section HTML (matches theme logic)
      const getSectionInnerHTML = (html, selector = ".shopify-section") => {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      };

      // 1. Update Cart Notification Section (The Drawer Items)
      const cartNotification = document.getElementById("cart-notification");
      if (cartNotification && parsedState.sections["cart-notification"]) {
        cartNotification.innerHTML = getSectionInnerHTML(
          parsedState.sections["cart-notification"]
        );
      }

      // 2. Update Cart Count Section
      const cartCount = document.getElementById("cart-notification-count");
      if (cartCount && parsedState.sections["cart-notification-count"]) {
        cartCount.innerHTML = getSectionInnerHTML(
          parsedState.sections["cart-notification-count"]
        );
      }

      // 3. Fallback for other cart count indicators in header
      document
        .querySelectorAll(".cart-count-bubble, .header__cart-count")
        .forEach((el) => {
          el.textContent = parsedState.item_count;
        });

      // Note: We don't need to re-enable 'input' because the entire section 
      // was replaced with fresh HTML. The new input is enabled by default.
    })
    .catch((err) => {
      console.error("Cart update failed:", err);
      input.disabled = false;
    });
}
})();